import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { format } from '@jd/jmtd-tools/es/number';
import { isString } from '@jd/jmtd-tools/es/is';
import classNames from '@jd/jmtd-tools/es/classnames';
import Tag from '../Tag';
import Icon from '../Icon';
import ConfigConsumer from '../ConfigConsumer';
import { getLocale } from '../locale';
/**
 * percent、number、currency
 */

export default function TableFormatterTag(_ref) {
  var rank = _ref.rank,
      _ref$significantFigur = _ref.significantFigures,
      significantFigures = _ref$significantFigur === void 0 ? 2 : _ref$significantFigur,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      _ref$inverseColor = _ref.inverseColor,
      inverseColor = _ref$inverseColor === void 0 ? false : _ref$inverseColor,
      _ref$formatType = _ref.formatType,
      formatType = _ref$formatType === void 0 ? 'percent' : _ref$formatType,
      _ref$currencySymbol = _ref.currencySymbol,
      currencySymbol = _ref$currencySymbol === void 0 ? '￥' : _ref$currencySymbol,
      noArrow = _ref.noArrow,
      _ref$goodBaseline = _ref.goodBaseline,
      goodBaseline = _ref$goodBaseline === void 0 ? 0 : _ref$goodBaseline,
      _ref$badBaseline = _ref.badBaseline,
      badBaseline = _ref$badBaseline === void 0 ? 0 : _ref$badBaseline;
  var type = {
    percent: 'percent',
    number: 'number',
    currency: "currency_".concat(currencySymbol)
  };
  return {
    monoSpaced: true,
    render: function render(value) {
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
        var locale = _ref2.locale;
        var labels = getLocale(locale).table; // 文案
        // 如果value是字符串，转化为数字

        if (isString(value)) {
          value = parseFloat(value);
        }

        var zero = value === 0;
        var notANumber = !zero && !value;
        var positive = value > 0;
        var className;
        var text;
        var tagProps;

        if (zero) {
          text = labels.fair;
          className = 'jmtd-table-formatter-tag-zero';
        } else if (notANumber) {
          if (rank) {
            text = '新入榜';
            className = 'jmtd-table-formatter-tag-new';
          } else {
            text = labels.noData;
            className = 'jmtd-table-formatter-tag-null';
          }
        } else {
          var absValue = Math.abs(value);
          var sign = Math.sign(value);
          var signMark = noArrow ? sign === -1 ? '-' : '+' : ''; // 在noArrow模式下，显示正负号

          if (formatType === 'percent') {
            text = absValue > 9999.99 ? /*#__PURE__*/React.createElement(React.Fragment, null, sign === -1 && noArrow ? '<' : '>', signMark, "9999.99", labels.times) : absValue > 99.9999 ? /*#__PURE__*/React.createElement(React.Fragment, null, signMark, format(absValue, "number_".concat(significantFigures)), labels.times) : "".concat(signMark).concat(format(absValue, "percent_".concat(significantFigures, "_0_1")));
          } else {
            text = "".concat(signMark).concat(format(absValue, "".concat(type[formatType], "_").concat(significantFigures)));
          }

          if (value >= goodBaseline) {
            className = classNames('jmtd-table-formatter-tag-up', {
              'jmtd-table-formatter-tag-green': !inverseColor,
              'jmtd-table-formatter-tag-red': inverseColor
            });
          } else if (value <= badBaseline) {
            className = classNames('jmtd-table-formatter-tag-down', {
              'jmtd-table-formatter-tag-green': inverseColor,
              'jmtd-table-formatter-tag-red': !inverseColor
            });
          } else {
            tagProps = {
              color: 'darkBlue'
            };
          }
        }

        return /*#__PURE__*/React.createElement(Tag, _extends({
          size: "small",
          bordered: false
        }, tagProps, {
          startIcon: !zero && !notANumber && !noArrow && /*#__PURE__*/React.createElement(Icon, {
            width: 8,
            className: positive && !inverse || !positive && inverse ? 'jmti-caret-up' : 'jmti-caret-down'
          }),
          className: classNames('jmtd-table-formatter-tag', className)
        }), text);
      });
    }
  };
}